module.exports = __webpack_public_path__ + "static/digiflynt-d1347bff6b9f7a3296fd63b8afaeb9d8.png";